import CheckCard from "./CheckCard/CheckCard";
import GradeCard from "./GradeCard/GradeCard";

import cardStyles from "./GradeCard/GradeCard.module.css";
import styles from "./StudentSuccess.module.css";

function StudentSuccess({ mentoria, workshop_fast_track, workshop }) {
	function isApproved(status) {
		if (
			status === "Concluído" ||
			status === "Em andamento" ||
			status === "Pendente"
		) {
			return true;
		}
		
		return false;
	}

	function colorStyle(status) {
		if (status == "Concluído") {
			return cardStyles.approved;
		} else if (status == "Em andamento") {
			return cardStyles.warning;
		} else {
			return cardStyles.reproved;
		}
	}

	return (
		<>
			<GradeCard
				title={"Fast Track"}
                subtitle={"Mentorias individuais"}
				finalGrade={mentoria.status ? mentoria.final_grade : '-'}
				maxGrade={mentoria.status ? mentoria.max_grade : '-'}
				approvedText={mentoria.status ? mentoria.status : ''}
				reprovedText={mentoria.status}
				customColorFunction={mentoria.status ? () => colorStyle(mentoria.status) : false}
				approved={mentoria.status ? isApproved(mentoria.status) : "default"}
				showIcon={false}
			/>
            <div className={styles.cardsContainer}>
                <CheckCard title={"Workshop Fast Track"} checks={workshop_fast_track} />
                <CheckCard title={"Workshop"} checks={workshop} />
            </div>
		</>
	);
}

export default StudentSuccess;
